// @archigraph r8DljQiU
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Container } from '../components/ui/Container';

export function NotFoundPage() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center py-16">
      <Container>
        <div className="max-w-md">
          <p className="text-xs uppercase tracking-widest text-primary mb-4 font-bold">
            // error
          </p>
          <h1 className="text-6xl font-bold text-text mb-2 font-mono">404</h1>
          <p className="text-xs text-text-lighter mb-8">
            Page not found. The resource you requested doesn't exist.
          </p>
          <Link to="/">
            <Button variant="ghost" size="md">
              &larr; Back home
            </Button>
          </Link>
        </div>
      </Container>
    </div>
  );
}
